import script from "./rolePage.vue?vue&type=script&setup=true&lang=js"
export * from "./rolePage.vue?vue&type=script&setup=true&lang=js"

import "./rolePage.vue?vue&type=style&index=0&id=0a38bd40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a38bd40"]])

export default __exports__